import React, { useState } from "react";
import { FormSelect } from "./FormSelect";

export const InstitutionSelect = ({
  institutions,
  selectedInstitution,
  onInstitutionChange,
  isLoading,
  t,
}) => {
  const [disabledInput, setDisabledInput] = useState(false);

  const handleDisabledInputChange = () => {
    setDisabledInput(!disabledInput);
    if (!disabledInput) {
      onInstitutionChange(null);
    }
  };

  return (
    <div className="form-group row mb-0">
      <label className="col-xl-3 col-lg-3 col-form-label">
        <input
          type="checkbox"
          value={disabledInput}
          onChange={handleDisabledInputChange}
        />
        <span /> {t("Toutes les institutions")}
      </label>
      <div className="col-lg-9 col-xl-6">
        <FormSelect
          value={selectedInstitution}
          onChange={onInstitutionChange}
          options={institutions || []}
          placeholder="Veuillez sélectionner une institution"
          isLoading={isLoading}
          isClearable
          isDisabled={disabledInput}
          t={t}
        />
      </div>
    </div>
  );
};
